import './Social.scss'

import {Icon} from '../ui/Icon'
import {Link} from '../../util/link'
import React from 'react'
import {style} from '../../util/style'

const styles = style('social', ['link'])

export type SocialType = {
	text?: string
	links?: Array<SocialLinkType>
}

export type SocialLinkType = {
	type: 'bluesky' | 'facebook' | 'instagram' | 'linkedin' | 'youtube'
	url: string
}

export const Social: React.FC<
	SocialType & {
		className?: string
	}
> = ({text, links, className}) => {
	if (!links || links.length === 0) return null

	return (
		<div className={styles().with(className)}>
			{text && <p className={styles('text')}>{text}</p>}
			<div className={styles('row')}>
				{links.map(
					(item) =>
						item &&
						item.type && (
							<div className={styles('row-item')}>
								<SocialLink key={item.type} {...item} />
							</div>
						)
				)}
			</div>
		</div>
	)
}

const SocialLink: React.FC<SocialLinkType> = ({type, url}) => {
	return (
		<Link
			to={url}
			title={switchLabel(type)}
			data-platform={switchLabel(type)}
			className={styles.link().mod(type)}
		>
			<Icon icon={type} />
		</Link>
	)
}

function switchLabel(type) {
	switch (type) {
		case 'bluesky':
			return 'Bluesky'
		case 'facebook':
			return 'Facebook'
		case 'instagram':
			return 'Instagram'
		case 'linkedin':
			return 'LinkedIn'
		case 'bluesky':
			return 'Bluesky'
		case 'youtube':
			return 'YouTube'
	}
}
